import {
  Component,
  KeyValueDiffer,
  KeyValueDiffers,
  Input,
  OnInit,
} from '@angular/core';
import { NonConformitaService } from 'src/app/services/non-conformita/non-conformita.service';
import { AppConstants } from 'src/environments/constants';
import { CommonUtils } from 'src/utils/CommonUtils';
import { first as _first } from 'rxjs/operators';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Router } from '@angular/router';
import { NonConformita } from 'src/app/model/nonConformita/NonConformitaModel';
import { DatePipe } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { StatoNonConformita } from 'src/app/model/nonConformita/NonConformita';
import { Observable } from 'rxjs';
import { Ordine } from 'src/app/model/ordini/Ordine';

@Component({
  selector: 'app-table-non-conformita-ordine',
  templateUrl: './table-non-conformita-ordine.component.html',
  styleUrls: ['./table-non-conformita-ordine.component.scss'],
  animations: [
    trigger('openClose', [
      state(
        'open',
        style({
          maxHeight: '100%',
          margin: '20px',
        })
      ),
      state(
        'close',
        style({
          height: '0px',
          margin: '0px',
        })
      ),
      transition('open=>close', animate('0.5s ease-out')),
      transition('close=>open', animate('0.5s ease-in')),
    ]),
  ],
})
export class TableNonConformitaOrdineComponent implements OnInit {
  differ: KeyValueDiffer<string, any>;
  downloadNonConformitaComplete = false;
  checkPaginator = false;
  nonConformitaPresenti = false;
  erroreGestitoMex: String = null;
  serverError: boolean = false;
  displayedColumns: string[] = [
    'codiceNC',
    'tipologiaNC',
    'fornitore',
    'ispettore',
    'dataCreazione',
    'stato',
    'actions',
  ];
  nonConformita: any[] = [];
  ordine: Ordine;
  expandedElement: string[] = [];
  _isTeamView: boolean = false;
  state = this.router.getCurrentNavigation()?.extras.state || null;
  public page: number;
  documento: any;
  sortControl = {
    colonna: { id: null },
    DATA_CREAZIONE: {
      isSortByData: true,
      desc: false,
      currentClass: 'arrow-down',
    },
    CODICE_NC: { isSortByNC: false, desc: false, currentClass: 'arrow' },
  };

  @Input() tipologiaUtente;
  @Input() set isTeamView(value: boolean) {
    if (!CommonUtils.isNotNullOrUndefined(this._isTeamView)) {
      this._isTeamView = value;
    } else if (value != this._isTeamView) {
      this._isTeamView = value;
      this.sortControl = {
        colonna: { id: null },
        DATA_CREAZIONE: {
          isSortByData: true,
          desc: false,
          currentClass: 'arrow-down',
        },
        CODICE_NC: { isSortByNC: false, desc: false, currentClass: 'arrow' },
      };
    }
  }

  @Input() idOrdine;
  @Input() codicePosizione!: string;
  tableHeaders: any[] = [];
  tableRows: any[];
  tableConfig: any;

  // ========== OVERLAY POSIZIONI ==========
  showOverlay = false;
  overlayTitle = '';
  overlayTableConfig: any;
  emptyImage: string =
    sessionStorage.getItem('theme') === 'dark'
      ? '../../assets/images/empty-state-dark.svg'
      : './../assets/images/empty-state-dark.svg';

  constructor(
    private router: Router,
    private nonConformitaServ: NonConformitaService,
    private differs: KeyValueDiffers,
    private dataPipe: DatePipe,
    private translate: TranslateService
  ) {
    this.differ = this.differs.find({}).create();
  }

  ngOnInit(): void {
    this.getList(this._isTeamView);
    this.loadAndTranslateTableHeaders();
    this.translate.onLangChange.subscribe(() => {
      this.loadAndTranslateTableHeaders();
      this.updateTableRows();
      this.patchOverlayCloseLabel();
    });
  }

getList(isTeamView: boolean) {
  this.downloadNonConformitaComplete = false;
  this.nonConformitaPresenti = false;
  this.erroreGestitoMex = null;
  this.serverError = false;
  this.nonConformita = [];

  let call$: Observable<any>;

  if (this.codicePosizione) {
    call$ = this.nonConformitaServ.getListNonConformitaFromPosizione(
      isTeamView,
      this.idOrdine,
      this.codicePosizione
    );
  } else {
    call$ = this.nonConformitaServ.getListNonConformitaFromOrdine(
      isTeamView,
      this.idOrdine
    );
  }

  call$.pipe(_first()).subscribe(
    res => {
      if (res['errorMex']) {
        this.erroreGestitoMex = res['errorMex'];
      } else {
        this.nonConformita = res['respObj'] || [];
        this.nonConformitaPresenti = this.nonConformita.length > 0;

        if (this.nonConformitaPresenti) {
          this.updateTableRows();
        }
      }

      this.downloadNonConformitaComplete = true;
      this.checkPaginator = true;
    },
    err => {
      this.serverError = true;
      this.downloadNonConformitaComplete = true;
      this.checkPaginator = true;
    }
  );
}



  onAnimationEvent(event: any) {}

  goToDetail(element) {
    this.router.navigate([AppConstants.NONCONFORMITA_ROUTE, element.id], {
      state: {
        documento: this.documento,
        page: this.page,
        sorting: this.sortControl,
      },
    });
  }

  ngDoCheck() {
    const change = this.differ.diff(this);
    if (change) {
      change.forEachChangedItem(item => {
        if (item.key === '_isTeamView') {
          this.erroreGestitoMex = null;
          this.downloadNonConformitaComplete = false;
          this.serverError = false;
          this.getList(this._isTeamView);
        }
      });
    }
  }

  private buildTableConfig(): void {
    if (!this.tableHeaders || this.tableHeaders.length === 0) return;

    this.tableConfig = {
      tableWidthPercentage: true,
      hasInfoHeader: false,
      tableAriaLabel: this.translate.instant('ordini.tabellaOrdiniPosizioni'),
      tableHeader: {
        tableCellsHeader: this.tableHeaders.map(h => ({
          text: h.text,
          columnId: h.columnId,
          columnWidth: h.width,
          textAlign: 'left' as const,
        })),
        hiddenHeader: false,
        rightIconSticky: true,
        secondRightIconSticky: true,
      },
      tableRows: (this.tableRows || []).map(row => ({
        tableCells: row.cells,
        rightIcon: 'icon-notes',
        secondRightIcon: 'icon-arrow-right',
      })),
    };
  }

  private loadAndTranslateTableHeaders(): void {
    const headerKeys = this.tableHeadersConfig.map(header => header.text);

    this.fetchTranslations(headerKeys).subscribe(translations => {
      this.tableHeaders = this.tableHeadersConfig.map(header => ({
        ...header,
        text: translations[header.text] || header.text,
      }));
      this.buildTableConfig();
    });
  }

  private fetchTranslations(keys: string[]): Observable<any> {
    return this.translate.get(keys);
  }

  private readonly tableHeadersConfig: any[] = [
    { text: 'nonConformita.codeNC', columnId: 'posizione', width: '10%' },
    { text: 'nonConformita.typologyNC', columnId: 'descrizione', width: '18%' },
    { text: 'ordini.supplier', columnId: 'codiceMateriale', width: '24%' },
    { text: 'ordini.snamInspector', columnId: 'utenti', width: '14%' },
    { text: 'nonConformita.date', columnId: 'quantita', width: '10%' },
    { text: 'nonConformita.state', columnId: 'stato', width: '24%' },
  ];

  private updateTableRows(): void {
    if (this.nonConformita && this.nonConformita.length > 0) {
      this.tableRows = this.nonConformita.map(nc =>
        this.mapNonConformitaToTableRow(nc)
      );
    } else {
      this.tableRows = [];
    }
    this.buildTableConfig();
  }

  private mapNonConformitaToTableRow(nC: NonConformita): any {
    const badge = this.getBadgeStatus(nC.stato);

    return {
      cells: [
        { type: 'text', text: nC.codice || '-', cellClickable: true },
        { type: 'text', text: nC.tipologia || '-', cellClickable: true },
        {
          type: 'text',
          text: nC.fornitore.ragioneSociale || '-',
          cellClickable: true,
        },
        {
          type: 'text',
          text:
            nC.ispettoreSnam?.nome || nC.ispettoreSnam?.cognome
              ? `${nC.ispettoreSnam?.nome || ''} ${nC.ispettoreSnam?.cognome || ''}`.trim()
              : '-',
          cellClickable: true,
        },
        {
          type: 'text',
          text: this.formatData(nC.dataCreazione),
          cellClickable: true,
        },
        {
          type: 'text-badge',
          text: this.translate.instant(nC.stato),
          badgeStatus: badge.notificationStatus,
          cellClickable: true,
          badgeCustomColor: badge.backgroundColor,
        },
      ],
      data: nC,
    };
  }

  private formatData(data: Date) {
    if (data) {
      return this.dataPipe.transform(data, 'dd.MM.yyyy');
    } else {
      return '-';
    }
  }

  getBadgeStatus(element: StatoNonConformita) {
    switch (element) {
      case StatoNonConformita.DA_CONFERMARE:
      case StatoNonConformita.DA_PRE_APPROVARE:
        return {
          notificationStatus: 'custom',
          badgeAriaLabel: element,
          backgroundColor: '#d6ae01',
        };

      case StatoNonConformita.APPROVATA:
        return {
          notificationStatus: 'confirm',
          badgeAriaLabel: element,
        };

      case StatoNonConformita.RITARDO:
        return {
          notificationStatus: 'error',
          badgeAriaLabel: element,
        };

      case StatoNonConformita.NUOVA:
        return {
          notificationStatus: 'warning',
          badgeAriaLabel: element,
        };

      case StatoNonConformita.ELIMINATA:
        return {
          notificationStatus: 'custom',
          badgeAriaLabel: element,
          backgroundColor: 'var(--neutral-use-6)',
        };

      case StatoNonConformita.BOZZA:
        return {
          notificationStatus: 'custom',
          badgeAriaLabel: element,
          backgroundColor: 'var(--text-fill-primary)',
        };

      case StatoNonConformita.PRE_APPROVATA:
        return {
          notificationStatus: 'custom',
          badgeAriaLabel: element,
          backgroundColor: 'var(--charts-violet-1)',
        };

      default:
        return {
          notificationStatus: 'neutral',
          badgeAriaLabel: element,
        };
    }
  }

  onClickRightAction(event: any): void {
    const index = event.detail.row;
    const nC = this.nonConformita[index];
    this.nonConformitaServ
      .getDettaglioNonConformitaService(false, nC.id)
      .pipe(_first())
      .subscribe(res => {
        const ncDetail = res['respObj'];
        const posizioni = ncDetail?.posNcOutputList || [];
        const codice = ncDetail?.codice || nC.codice;
        this.translate
          .get('nonConformita.overlayTitle', { codice })
          .subscribe(title => (this.overlayTitle = title));
        this.overlayTableConfig = this.buildOverlayTableConfig(posizioni);
        this.showOverlay = true;
        setTimeout(() => {
          this.patchOverlayCloseLabel();
        });
      });
  }

  private patchOverlayCloseLabel(): void {
    const overlays = document.querySelectorAll('ds-overlay-fullscreen') as any;
    const host = overlays[overlays.length - 1];
    if (!host) return;

    const shadow = host.shadowRoot;
    if (!shadow) return;

    const closeButton = shadow.querySelector(
      'ds-button[button-label="Chiudi"]'
    ) as any;
    const span = closeButton?.shadowRoot?.querySelector('.button-text');
    if (span) {
      span.textContent = this.translate.instant('sidenav.Chiudi');
    }
  }
  closeModal(event: any): void {
    this.showOverlay = false;
  }

  private buildOverlayTableConfig(posizioni: any[]): any {
    return {
      tableWidthPercentage: true,
      tableHeader: {
        tableCellsHeader: [
          {
            text: this.translate.instant('nonConformita.numeroOrdine'),
            textAlign: 'left',
            columnWidth: '15%',
            columnId: 'numeroOrdine',
          },
          {
            text: this.translate.instant('nonConformita.position'),
            textAlign: 'left',
            columnWidth: '15%',
            columnId: 'posizione',
          },
          {
            text: this.translate.instant('nonConformita.materialCode'),
            textAlign: 'left',
            columnWidth: '25%',
            columnId: 'codiceMateriale',
          },
          {
            text: this.translate.instant('nonConformita.description'),
            textAlign: 'left',
            columnWidth: '25%',
            columnId: 'descrizione',
          },
          {
            text: this.translate.instant('nonConformita.quantities'),
            textAlign: 'left',
            columnWidth: '10%',
            columnId: 'quantita',
          },
          {
            text: this.translate.instant('nonConformita.udm'),
            textAlign: 'left',
            columnWidth: '10%',
            columnId: 'udm',
          },
        ],
        hiddenHeader: false,
      },
      tableRows: posizioni.map(el => {
        const tolleranza = el.tolleranzaEccesso
          ? el.quantita + el.tolleranzaEccesso * 100
          : el.quantita;
        return {
          tableCells: [
            { type: 'text', text: el.numeroOrdine || '-' },
            {
              type: 'text-icon',
              text: el.codicePosizione ? `Pos/${el.codicePosizione}` : '-',
              icon: el.isPriorita ? 'icon-bookmark-filled' : 'icon-bookmark',
            },
            { type: 'text', text: el.codiceMateriale || '-' },
            { type: 'text', text: el.descrizione || '' },
            { type: 'text', text: `${tolleranza ?? '-'}` },
            { type: 'text', text: el.unitaMisura || '' },
          ],
          rowClickable: false,
        };
      }),
    };
  }

  onClickSecondRightAction(event: any): void {
    const index = event.detail.row;
    const nC = this.nonConformita[index];
    this.router.navigate(['/non-conformita/', nC.id]);
  }
}
